/** @jsxImportSource @emotion/react */

import styled from '@emotion/styled';
import { scrollbar } from 'shared/styles/scrollbar';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  width: 100%;
  overflow-y: auto;
  ${({ theme }) => scrollbar(theme)}
  background-color: ${({ theme }) => theme.colors.SurfaceRaisinBlack50};

  & .header {
    margin-bottom: 20px;
  }

  & .content {
    margin-block: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  & .left,
  & .right {
    width: 50%;
    display: flex;
    flex-direction: column;
    height: auto;
  }

  & .left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 40px 110px 50px 50px;

    & .left-container {
      margin-left: auto;
      width: min-content;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }

  & .right {
    padding: 40px 50px 50px 110px;
    align-self: stretch;
  }

  & .footer {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    gap: 10px;
    flex-wrap: wrap;
  }

  @media (max-width: 1023px) {
    & .right {
      display: none;
    }

    & .left {
      width: 100%;
      padding: 20px;
      align-items: center;

      & .left-container {
        margin-left: 0;
        width: 100%;
        align-items: center;
      }
    }

    & .content {
      width: 100%;
      max-width: 410px;
    }
  }
`;

export const AlreadyContainer = styled.div`
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.SurfaceWhite};
  display: flex;
  width: 100%;
  justify-content: center;
  gap: 4px;

  margin-top: 32px;
`;

export const FormContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.SurfaceIndependence40};
  box-sizing: border-box;
  border-radius: 8px;
  padding: 30px;
  width: 404px;

  display: flex;
  flex-direction: column;
  justify-content: center;

  ${({ theme }) => scrollbar(theme)};

  @media (max-width: 1023px) {
    width: 100%;
  }
`;
